import { render, staticRenderFns } from "./component-c6d2ee83.vue?vue&type=template&id=060dd857&scoped=true&"
import script from "./component-c6d2ee83.vue?vue&type=script&lang=js&"
export * from "./component-c6d2ee83.vue?vue&type=script&lang=js&"
import style0 from "./component-c6d2ee83.vue?vue&type=style&index=0&id=060dd857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060dd857",
  null
  
)

export default component.exports